import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AdapterBuilder, ComponentSync, LL_H_C, TS_Tree } from '@nu-art/thunderstorm-frontend/index';
import { _keys, sortArray } from '@nu-art/ts-common';
import './QJSONViewer.scss';
import { ICONS } from '@app/styles';
const treeRendererMap = {
    root: (props) => _jsx("div", { children: "root" }),
    item: (props) => _jsx(JSONViewerNodeRenderer, { ...props })
};
export class QJSONViewer extends ComponentSync {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        state.item = nextProps.item;
        if (nextProps.filterGenerated) {
            _keys(state.item).map(key => key.startsWith('_') && delete state.item[key]);
        }
        return state;
    }
    prepareTree = () => {
        const tree = {
            type: 'root',
            item: this.state.item,
        };
        const items = sortArray(_keys(this.state.item)).map(key => ({ key, value: this.state.item[key] }));
        tree._children = items.map(item => this.prepareTreeItem(item));
        return tree;
    };
    prepareTreeItem = (item) => {
        const treeItem = {
            type: 'item',
            item
        };
        if (typeof item.value === 'object') {
            if (Array.isArray(item.value))
                treeItem._children = item.value.map((child, i) => ({
                    key: `${i}`,
                    value: child
                })).map(child => this.prepareTreeItem(child));
            else {
                if (item.value === null)
                    return { type: 'item', item };
                treeItem._children = _keys(item.value).map(key => ({
                    key: String(key),
                    value: item.value[key]
                })).map(child => this.prepareTreeItem(child));
            }
        }
        return treeItem;
    };
    resolveCollapseIcon = (props) => {
        if (!props.node.adapter.isParent(props.item))
            return _jsx(_Fragment, {});
        const className = _className('node-icon', props.node.expanded ? 'expanded' : undefined);
        return _jsx(ICONS.treeCollapse.component, { className: className });
    };
    render() {
        const tree = this.prepareTree();
        const treeAdapter = AdapterBuilder()
            .tree()
            .multiRender(treeRendererMap)
            .setExpandCollapseRenderer(this.resolveCollapseIcon)
            .hideRoot()
            .setData(tree)
            .build();
        return _jsx(TS_Tree, { adapter: treeAdapter, className: 'q-json-viewer' });
    }
}
class JSONViewerNodeRenderer extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return { expanded: nextProps.node.expanded };
    }
    constructor(props) {
        super(props);
    }
    resolveDataStyle = (value) => {
        const style = {
            'width': 0,
            'flexGrow': 1,
            'WhiteSpace': 'nowrap',
            'overflow': 'hidden',
            'textOverflow': 'ellipsis',
            'color': '#000000',
        };
        switch (typeof value) {
            case 'string':
                style.color = '#e67e22';
                break;
            case 'boolean':
                style.color = '#bf95d0';
                break;
            case 'number':
                if (isNaN(value))
                    style.color = '#e0e0e0';
                else
                    style.color = '#2ecc71';
                break;
            case 'undefined':
                style.color = '#000';
                break;
            case 'object':
                if (value === null)
                    style.color = '#f1c40f';
                break;
            default:
                style.color = '#000000';
                break;
        }
        return style;
    };
    render() {
        const { key, value } = this.props.item;
        const style = this.resolveDataStyle(value);
        if (typeof value !== 'object') {
            return _jsxs(LL_H_C, { className: 'match_width', style: { gap: '8px' }, children: [_jsxs("span", { style: { flexShrink: 0 }, children: [key, ":"] }), _jsx("span", { style: style, children: `${value}` })] });
        }
        return _jsxs(LL_H_C, { className: 'match_width', style: { gap: '8px' }, children: [_jsxs("span", { style: { flexShrink: 0 }, children: [key, ":"] }), !this.state.expanded && _jsx("span", { style: style, children: JSON.stringify(value) })] });
    }
}
//# sourceMappingURL=QJSONViewer.js.map